import { defineStore } from 'pinia';

export const useLoginStore = defineStore('login', {
    state: () => ({
        isLoginNextStep: false,
        errorText: null,
        email: null,
        code: null,
    }),
    actions: {
        toggleLoginStep() {
            this.errorText = null;
            this.isLoginNextStep = !this.isLoginNextStep;
        },
        sendCode(email, token) {
            this.email = email;

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "RequestVerificationToken": token
                }
            };

            fetch("/umbraco/surface/loginform/login?email=" + this.email, requestOptions)
                .then(response => {
                    if (!response.ok) {
                        this.errorText = response.status === 429 ? "Du har prøvd for mange ganger. Vent litt og prøv igjen." : "Noe gikk galt. Prøv igjen."
                        this.isLoginNextStep = false;
                    }
                });
        }
    }
});
